import React from 'react';
import { Table, Input } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { array, number } from 'prop-types';
import TicketsListItem from './TicketsListItem';

const propTypes = {
  tickets: array.isRequired,
  total: number.isRequired,
};

const defaultProps = {
  tickets: [],
  total: 0,
};

const TicketsList = ({ tickets }) => (
  <Table className="tickets-list no-margin" bordered responsive>
    <thead>
      <tr>
        <th>
          {/* <FormattedMessage id="tickets.id.theme_4" defaultMessage="ID">
            {str => <Input className='form-control-in-table-header' placeholder={str} />}
          </FormattedMessage> */}
          <FormattedMessage id="tickets.id.theme_4" defaultMessage="ID" />
        </th>
        <th>
          {/* <FormattedMessage id="tickets.title.theme_4" defaultMessage="Title">
            {
              string => <Input className='form-control-in-table-header' placeholder={string} />
            }
          </FormattedMessage> */}
          <FormattedMessage id="tickets.title.theme_4" defaultMessage="Title" />
        </th>
        <th>
          <FormattedMessage id="tickets.answers.theme_4" defaultMessage="Answers" />
        </th>
        <th>
          {/* <FormattedMessage id="tickets.status" defaultMessage="Status">
            {
              string => <Input type='select' name='select' className='form-control-in-table-header'>
                <option>Отправлен</option>
                <option disabled selected>Статусы</option>
                <option>Прочитан</option>
                <option>Вам ответили</option>
                <option>Запрос решен</option>
              </Input>
            }
          </FormattedMessage> */}
          <FormattedMessage id="tickets.status" defaultMessage="Status" />
        </th>
        <th>
          <FormattedMessage id="tickets.created" defaultMessage="Created" />
        </th>
      </tr>
    </thead>
    <tbody>
      {tickets.length > 0 &&
        tickets.map(ticket => <TicketsListItem key={ticket.id} ticket={ticket} />)}
    </tbody>
  </Table>
);

TicketsList.propTypes = propTypes;
TicketsList.defaultProps = defaultProps;

export default TicketsList;
